import { render, staticRenderFns } from "./ContactLinks.vue?vue&type=template&id=61e94f37&scoped=true"
import script from "./ContactLinks.vue?vue&type=script&lang=js"
export * from "./ContactLinks.vue?vue&type=script&lang=js"
import style0 from "./ContactLinks.vue?vue&type=style&index=0&id=61e94f37&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e94f37",
  null
  
)

export default component.exports